// @flow
import { withStyle } from 'styletron-react'
import { styled } from 'mz-ui-kit'
import { HTMLInputElement } from 'mz-ui-kit/core/Input/elements'

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '60px',
})

const arrowStyle = ($palette) => ({
  borderStyle: 'solid',
  borderColor: `${$palette('PRIMARY')}`,
  borderWidth: '0 3px 3px 0',
  display: 'inline-block',
  padding: '3px',
  height: '10px',
  width: '10px',
})

export const Picker = styled<{
  $operation?: 'down' | 'up',
}>('div', ({ $operation }) => ({
  width: '100%',
  height: '30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: $operation === 'down' ? '8px' : 0,
  paddingTop: $operation === 'up' ? '8px' : 0,
  cursor: 'pointer',
}))

export const ArrowUp = styled<{}>('i', ({ $palette }) => ({
  ...arrowStyle($palette),
  transform: 'rotate(-135deg)',
  color: `${$palette('PRIMARY')}`,
}))

export const ArrowDown = styled<{}>('i', ({ $palette }) => ({
  ...arrowStyle($palette),
  transform: 'rotate(45deg)',
  color: `${$palette('PRIMARY')}`,
}))

export const Divider = styled<{}>('div', ({ $palette }) => ({
  width: '100%',
  borderTop: `1px solid ${$palette('GRAY')}`,
}))

export const Value = withStyle(HTMLInputElement, {
  fontSize: '20px',
  paddingTop: '10px',
  paddingBottom: '10px',
  paddingLeft: '10px',
  paddingRight: '10px',
  margin: '4px 0',
  width: 'calc(100% - 30px)',
  border: 'none',
  textAlign: 'center',
})
